import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

const SUMMARY_THRESHOLD = 10;

export default class extends Controller {
  connect() {
    if (this.element.tomselect) return;

    const controller = this;

    this.tomSelect = new TomSelect(this.element, {
      create: false,
      maxOptions: 5000,
      plugins: {
        checkbox_options: {
          checkedClassNames: ["ts-checked"],
          uncheckedClassNames: ["ts-unchecked"]
        }
      },
      onChange: () => {
        controller.updateSummaryDisplay();

        if (this.element.getAttribute("multiple") === "multiple") return;

        controller.tomSelect.close();
        controller.tomSelect.blur();
      },
      onItemAdd() {
        const dropdownContent = this.dropdown_content;
        const scrollTop = dropdownContent ? dropdownContent.scrollTop : 0;

        // this.setTextboxValue("");
        this.refreshOptions(false);

        if (dropdownContent) {
          requestAnimationFrame(() => {
            dropdownContent.scrollTop = scrollTop;
          });
        }
      },
      onItemRemove() {
        const dropdownContent = this.dropdown_content;
        const scrollTop = dropdownContent ? dropdownContent.scrollTop : 0;

        // this.setTextboxValue("");
        this.refreshOptions(false);

        if (dropdownContent) {
          requestAnimationFrame(() => {
            dropdownContent.scrollTop = scrollTop;
          });
        }
      },
      onInitialize() {
        // ここでの `this` は TomSelect インスタンス自身
        controller.updateSummaryDisplay(this);
      }
    });
  }

  updateSummaryDisplay(instance = this.tomSelect) {
    const isMultiple = this.element.getAttribute("multiple") === "multiple";
    if (!isMultiple) return;

    const wrapper = instance.wrapper;
    const count = instance.items.length;

    let summary = wrapper.querySelector(".ts-summary-label");

    if (count > SUMMARY_THRESHOLD) {
      wrapper.classList.add("ts-summary-mode");

      if (!summary) {
        summary = document.createElement("div");
        summary.className = "ts-summary-label";
        instance.control.appendChild(summary); // 先頭に挿入
      }
      summary.textContent = `${count} options selected`;
    } else {
      wrapper.classList.remove("ts-summary-mode");
      if (summary) summary.remove();
    }
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }

    if (this.element.tomselect) {
      this.element.tomselect = null;
    }

    this.tomSelect = null;
  }
}
